<template>
    <node-view-wrapper class="sezar-attribute" :class="{ active }" :contenteditable="false">
        <a-popover v-model="active" trigger="click" placement="left" :overlayClassName="'no-padding'">
            <div slot="content" class="sezar-attribute-popover">
                <AttributePicker
                    :default-selected="node.attrs.name"
                    :pick="onPicked"
                    :whatsapp-mode="node.attrs.whatsappMode"
                    :allowed-attributes="parseAllowedAttributes()"
                />
            </div>

            <span @click="active = true" class="logos pop-content w-100" @contextmenu.prevent="showContextMenu($event)">
                <AttributeIconPreview :attribute="node.attrs.name" />
                <span class="ml-2">
                    <AttributeLabel :attribute="node.attrs.name" />
                </span>
            </span>
        </a-popover>
        <a-dropdown v-if="contextMenuVisible" :visible="contextMenuVisible" :trigger="[]" @visibleChange="onDropdownVisibleChange">
            <ul slot="overlay" class="custom-context-menu">
                <li @click="openEditAttribute">{{ $t("chatbotv2.edit") }}</li>
            </ul>
            <div style="position: fixed; z-index: 9999;" :style="contextMenuStyle"></div>
        </a-dropdown>
        <a-modal v-model="editModalVisible" :title="$t('chatbotv2.manualAttributeEdit')" :footer="null" @cancel="editModalVisible = false">
            <div style="margin-bottom: 10px;">{{ $t("chatbotv2.manualAttributeEntry") }}</div>
            <a-input v-model="manualAttribute" @keyup.enter="saveManualAttribute" placeholder="block.123.result.sessions.buckets.$..*" />
            <div style="margin-top: 16px; text-align: right;">
                <a-button @click="editModalVisible = false">{{ $t("message.cancel") }}</a-button>
                <a-button type="primary" style="margin-left: 8px;" @click="saveManualAttribute">{{ $t("message.save") }}</a-button>
            </div>
        </a-modal>
    </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-2";
import log2 from "../../../../../../../utils/log2";
import AttributePicker from "../../pickers/AttributePicker";
import SYSTEM_PUBSUB from "../../../../../../../utils/systemPubSub";
import AttributeIconPreview from "../AttributeIconPreview";
import AttributeLabel from "./AttributeLabel";

const log = log2("SezarAttribute");
export default {
    name: "SezarAttribute",
    props: nodeViewProps,
    components: {
        NodeViewWrapper,
        AttributePicker,
        AttributeIconPreview,
        AttributeLabel,
    },
    data() {
        return {
            active: false,
            contextMenuVisible: false,
            contextMenuStyle: {},
            editModalVisible: false,
            manualAttribute: "",
        };
    },
    methods: {
        parseAllowedAttributes() {
            log("parseAllowedAttributes", this.node.attrs.allowedAttributes);
            return this.node.attrs.allowedAttributes.split(",");
        },
        getContent() {
            const attributeName = this.node.attrs.name;
            if (attributeName === "akinon_order_id") return "Order ID";
            else return attributeName;
        },
        onPicked(newAttribute) {
            log("onPicked", newAttribute, this.node.attrs);
            this.active = false;
            log("CB_ATTRIBUTE_CHANGED event sending", this.node.attrs["data-id"]);
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_ATTRIBUTE_CHANGED, {
                attributeId: this.node.attrs["data-id"],
                name: newAttribute,
            });
        },
        toggleActive() {
            log("toggleActive");
            this.active = !this.active;
        },
        showContextMenu(event) {
            this.contextMenuVisible = true;
            this.contextMenuStyle = {
                left: event.clientX + "px",
                top: event.clientY + "px",
            };
            window.addEventListener("click", this.handleWindowClickContextMenu, true);
        },
        onDropdownVisibleChange(visible) {
            if (!visible) this.closeContextMenu();
        },
        closeContextMenu() {
            this.contextMenuVisible = false;
            window.removeEventListener("click", this.handleWindowClickContextMenu, true);
        },
        handleWindowClickContextMenu(e) {
            if (!this.$el.contains(e.target)) {
                this.closeContextMenu();
            }
        },
        openEditAttribute() {
            this.closeContextMenu();
            this.manualAttribute = this.node.attrs.name;
            this.editModalVisible = true;
        },
        saveManualAttribute() {
            if (!this.manualAttribute) return;
            this.editModalVisible = false;
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_ATTRIBUTE_CHANGED, {
                attributeId: this.node.attrs["data-id"],
                name: this.manualAttribute,
            });
        },
    },
    mounted() {
        this.subscriber = SYSTEM_PUBSUB.stream.subscribe(({ type, payload }) => {
            if (
                type === SYSTEM_PUBSUB.MESSAGE_TYPES.CB_SHOW_ATTRIBUTE_MODAL &&
                payload.attributeId === this.node.attrs["data-id"]
            ) {
                log("CB_SHOW_ATTRIBUTE_MODAL event received", payload);
                this.active = true;
            }
        });
    },
    beforeDestroy() {
        this.subscriber.unsubscribe();
    },
};
</script>

<style scoped lang="scss">
.pop-content {
    gap: 2px;
    height: 18px;
    display: inline-flex;

    .material-icons {
        font-size: 15px;
        padding-top: 2px;
        text-align: center;
    }
}

.sezar-attribute {
    display: inline-flex;
    background: #ffdc66;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    border-radius: 10px;
    box-decoration-break: clone;
    padding: 2px 5px;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-weight: 700;
    letter-spacing: 1.2px;
    gap: 6px;
    user-select: none;

    &.active {
        background: #006cff;
        cursor: pointer;
        color: #fff;
    }
}

.custom-context-menu {
    list-style: none;
    margin: 0;
    padding: 0;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    min-width: 160px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    z-index: 99999;
    position: relative;
    li {
        padding: 8px 16px;
        cursor: pointer;
        &:hover {
            background: #f5f5f5;
        }
    }
}
</style>
